import {Component, Injector, OnInit} from '@angular/core';
import {Validators} from '@angular/forms';
import {InputBase} from '../../input-base.abstract';

@Component({
    selector: 'surveys-element-input-text',
    templateUrl: './element-input-text.component.html',
    styleUrls: ['./element-input-text.component.scss']
})
export class ElementInputTextComponent extends InputBase<string> implements OnInit {
    public maxLength = 100;
    /* istanbul ignore next */
    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();

        this.enableAutoSave();

        this.control.setValidators([Validators.maxLength(100)]);
    }

    protected transformBeforeSave(value: string): string | undefined {
        // delete the response if the string is blank
        if (!value || !value.length) return undefined;

        return value;
    }

    protected shouldSave(value: string | undefined): boolean {
        // this removes the response from the DB if there is one
        if (value === undefined) return true;

        return this.control.valid;
    }
}
